const FrPrizes = () => {
  return (
    <>
      <section>
        <p>
          Veuillez vous référer aux informations « Comment jouer » situées sur
          le site web (
          <a
            href="https://fr.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://fr.nbafantasy.nba.com/help/rules
          </a>
          ) pour obtenir tous les détails sur l'accumulation des points.
        </p>
        <p>Il y aura 30 gagnants au total pour le concours, comme suit :</p>
        <p>Saison longue</p>
        <p>
          Les prix seront attribués aux cinq (5) meilleurs participants ayant
          accumulé le plus de points sur une saison. Pour éviter toute
          ambiguïté, il y aura cinq (5) prix à gagner au total, et NON cinq (5)
          prix pour chaque pays.
        </p>
        <p>
          Un (1) prix sera attribué par semaine (vingt-cinq (25) au total) au
          participant ayant obtenu le plus de points au cours d’une semaine
          donnée. Pour éviter toute ambiguïté, il y aura un (1) prix
          hebdomadaire total à gagner, et NON un (1) prix hebdomadaire pour
          chaque pays.
        </p>
        <p>
          En cas d'égalité entre les participants pour les prix de la saison ou
          pour un prix hebdomadaire, un système de départage sera mis en place
          pour déterminer le gagnant. Le participant qui sera départagé sera
          celui qui s'est connecté et a créé son équipe en premier (à la date la
          plus proche) sur la base des données collectées par le sponsor.
        </p>
      </section>
      <section>
        <h3>Grand prix - Premier (1er) classement général</h3>
        <p>
          Il y aura un (1) gagnant du grand prix (« gagnant du grand prix ») qui
          sera attribué au participant ayant accumulé le plus grand nombre de
          points pendant la durée du concours.
        </p>
        <p>Le « Grand Prix » comprend :</p>
        <ul>
          <li>
            <p>
              Le transport de la résidence des gagnants à Paris, France, soit
              par deux (2) billets d’avion aller-retour en classe économique de
              l’aéroport international le plus proche de la résidence des
              gagnants à un aéroport à Paris, France, soit par des billets de
              train aller-retour de la gare la plus proche de la résidence des
              gagnants à Paris, France (tel que déterminé et communiqué par le
              Sponsor à sa seule discrétion).
            </p>
            <ul>
              <li>
                <p>
                  Le choix spécifique des sièges est à la seule discrétion du
                  Sponsor.
                </p>
              </li>
              <li>
                <p>
                  Le mode de transport, les dates et les heures exactes seront
                  déterminés par le Sponsor à sa seule discrétion
                </p>
              </li>
            </ul>
          </li>

          <li>
            <p>
              Une (1) chambre d’hôtel pour deux (2) à Paris pour un total de
              trois (3) nuits dans un hôtel 3-4 étoiles
            </p>
            <ul>
              <li>
                <p>
                  Les hôtels, les chambres et les dates seront choisis par le
                  Sponsor à sa seule discrétion
                </p>
              </li>
            </ul>
          </li>

          <li>
            <p>
              Deux (2) billets pour un (1) match de la NBA à Paris pendant la
              saison 2027-28 de la NBA (le « Match »)
            </p>
            <ul>
              <li>
                <p>
                  La date exacte du match est à l'entière discrétion du
                  Commanditaire.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Un trophée de la première place, remis en personne ou par service
              de messagerie à l'adresse du gagnant, à la seule discrétion de
              l'Organisateur.
            </p>
          </li>
        </ul>
        <p>
          La valeur totale approximative de vente du Grand Prix est de 2 500,00
          €.
        </p>
        <p>
          Le gagnant peut désigner un (1) ami ou un membre de sa famille pour
          l'accompagner (l’« invité »).
        </p>
        <p>
          Les gagnants du Grand Prix d’une saison précédente ne sont pas
          éligibles pour réclamer le Grand Prix. Dans ce cas, le Grand Prix sera
          attribué au Participant éligible suivant, et le gagnant du Grand Prix
          non éligible recevra à la place le prix de la deuxième (2e) place.
        </p>
      </section>
      <section>
        <p>
          Quatre (4) prix secondaires supplémentaires pour l'ensemble de la
          saison - Deuxième (2e) à cinquième (5e) classement général Ces quatre
          (4) prix secondaires supplémentaires seront attribués aux participants
          ayant accumulé le deuxième (2e), le troisième (3e), le quatrième (4e)
          et le cinquième (5e) plus grand nombre de points pendant la durée du
          concours (chacun étant un « gagnant du deuxième prix »).
        </p>
        <ul>
          <li>
            <p>
              Prix de la deuxième (2e) place : Carte cadeau NBA Store x 200,00 €
              à{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prix de la troisième (3e) place : Carte cadeau NBA Store x 200,00
              € à{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prix de la quatrième (4e) place : Carte cadeau NBA Store x 200,00
              € à{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prix de la cinquième (5e) place : Carte cadeau NBA Store x 200,00
              € à{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Toutes les semaines :</h3>
        <p>
          Vingt-cinq (25) prix supplémentaires seront attribués au participant
          ayant obtenu le plus grand nombre de points au cours d'une semaine
          donnée (chacun étant appelé « Gagnant du prix hebdomadaire »). Un (1)
          prix hebdomadaire sera attribué par semaine x 25 semaines de durée
          totale du concours.
        </p>
        <p>
          Le prix hebdomadaire consistera en une copie numérique de NBA 2K27 et
          une carte-cadeau NBA Store de 100,00 € sur{" "}
          <a
            href="https://nbastore.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://nbastore.eu
          </a>{" "}
          (à déterminer par le sponsor à sa seule discrétion). La valeur de
          vente totale approximative de chaque prix est de 150,00€.
        </p>
        <p>
          Pour pouvoir gagner les prix hebdomadaires, les utilisateurs doivent
          s'être inscrits au jeu avant le début de la saison ou au moins 14
          jours avant le début de la semaine de jeu concernée.
        </p>
        <p>
          Une liste complète des semaines de jeu est disponible dans la section{" "}
          <a
            href="https://fr.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            comment jouer
          </a>
          . Les semaines de jeu peuvent être modifiées à la seule discrétion du
          sponsor.
        </p>
      </section>
      <section>
        <h3>Éligibilité:</h3>
        <p>
          La promotion est limitée aux résidents de l'Autriche, la Belgique, la
          République tchèque, le Danemark, la Finlande, la France, l'Allemagne,
          la Grèce, la Hongrie, l'Irlande, les Pays-Bas, la Norvège, le
          Portugal, la Serbie, l'Espagne, la Suisse et le Royaume-Uni (ensemble,
          le « Territoire »), qui sont âgés de dix-huit (18) ans ou plus à la
          date d'envoi de l'inscription au concours (chacun, un « participant
          »). Pour éviter toute ambiguïté, les résidents en dehors des
          juridictions susmentionnées et/ou les participants n'ayant pas atteint
          l'âge de dix-huit (18) ans à la date d'envoi de l'inscription au
          concours ne sont pas autorisés à participer à cette promotion. Le
          Commanditaire, tel que défini ci-dessous, se réserve le droit de
          confirmer l'éligibilité de tout participant, y compris de vérifier son
          âge.
        </p>
      </section>
    </>
  );
};

export { FrPrizes };
